import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subaward Monitoring Activity Assignment: The association(s) between subaward and monitoring activity.',
    name: 'Subaward Monitoring Activity Assignments',
    partialId: PartialId.Standard.create('subaward_monitor_act_assign'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
